import type { RootState } from 'store/root/reducers';

const getCurrentState = (state: RootState) => state['shop'];

const shopSelectors = {
  staff: (state: RootState) => getCurrentState(state).staffs,
  staffAvailable: (state: RootState) => getCurrentState(state).staffAvailable,
  staffAvailableLoading: (state: RootState) => getCurrentState(state).staffAvailableLoading,
  categories: (state: RootState) => getCurrentState(state).categories,
  allServices: (state: RootState) => getCurrentState(state).allServices,
  scheduleBooking: (state: RootState) => getCurrentState(state).scheduleBooking,
  categoriesAll: (state: RootState) => {
    const currentState = getCurrentState(state);
    const categories = currentState.categories;
    const allServices = currentState.allServices;
    if (!categories?.length) return [];
    return ([
      { id: 'all', name: 'All', services: [...allServices] },
    ].concat(categories))
  },
  shopLoading: (state: RootState) => getCurrentState(state).shopLoading,
  shopInfo: (state: RootState) => getCurrentState(state).shopInfo,
  allBanner: (state: RootState) => getCurrentState(state).allBanner,
  staffShopsByPhone: (state: RootState) => getCurrentState(state).staffShopsByPhone,
  currentSalon: (state: RootState) => getCurrentState(state).currentSalon,
};

export default shopSelectors;
